import { AvailabilityItemType, RoomType } from '../../../types.ts';
import React from 'react';
import TableItem from './TableItem.tsx';

interface TableListProps {
  liveAvailabilityItem: AvailabilityItemType;
}

const TableList: React.FC<TableListProps> = ({ liveAvailabilityItem }) => (
  <tbody>
    {liveAvailabilityItem.Rooms.map((room: RoomType, index: number) => (
      <TableItem
        liveAvailabilityItem={liveAvailabilityItem}
        room={room}
        index={index}
        key={`room_${index + 1}`}
      />
    ))}
  </tbody>
);

export default TableList;
